import { datadogLogs } from '@datadog/browser-logs';

import { bff } from './client';

import { PartnerSummaryResponse } from './types';

export async function getPartner() {
  try {
    const { data } = await bff.get<PartnerSummaryResponse>('/v1/partners/me');

    return data;
  } catch (error) {
    datadogLogs.logger.error('Error while fetching partner', {
      error,
    });

    throw new Error(
      `Error while fetching partner: ${JSON.stringify(error, null, 2)}`,
    );
  }
}

export * from './types';
